import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { FTPDownloadViewModel } from './../../ViewModels/FTPDownloadViewModel';
import { GetFTPDownloadByProfileIdAndType } from './Params/GetFTPDownloadByProfileIdAndType';

/**
 * API for FTP Download systems (e.g. Infinx)
 */
export class FTPDownloadApi {
    private route = '/FTPDownload';

    /**
     * Fetch an FTP download by profile ID and profile type
     * @param profileId the ID of the profile
     * @param profileType the type of the profile
    */
    public getFTPDownloadByProfileIdAndType = (params: GetFTPDownloadByProfileIdAndType): ApiResponse<FTPDownloadViewModel> => {
        return api().get(`${this.route}`, { params });
    };

    /**
     * Fetch an FTP download by it's id
     * @param id the ID of the FTP download
    */
    public getFTPDownloadById = (params: { id: number }): ApiResponse<FTPDownloadViewModel> => {
        return api().get(`${this.route}`, { params });
    };
}
